module.exports = __webpack_public_path__ + "img/home-line4-img4.858acbd0.png";